import { render, staticRenderFns } from "./InvPT_Footer.vue?vue&type=template&id=faf32d82"
import script from "./InvPT_Footer.vue?vue&type=script&lang=js"
export * from "./InvPT_Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports